<template>
  <div class="setup-account" style="height: 100%;">
    <top-header></top-header>
    <div class="titlr">
      <h3>Usage Quota</h3>
    </div>
    <div id="my_dataviz"></div>
    <invite ref="invite"></invite>
    <logout ref="logout"></logout>
  </div>
</template>
<style scoped>
.titlr {
  margin: 2em 0;
}

svg {
  background: #44444403;
  border: 1px solid #e8f3fc;
}

.close svg {
  border: none !important;
}
</style>

<script>
import TopHeader from '@/components/Top-Header'
import logout from '@/components/Logout'
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
import Invite from '@/components/Invite';
export default {
  components: {
    TopHeader,
    Invite,
    logout
  },
  data() {
    return {
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      position: localStorage.getItem('position'),
      account_type: localStorage.getItem('account_type')
    }
  },
  methods: {
    logout() {
      this.$refs.logout.logout()
    },
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'GET_DIRECTORY_CHILDREN',
      'CLOSE_FILE_INFO',
      'SET_PATH',
      'UPDATE_SLIDEIN',
      'UPDATE_SLIDEOUT',
      'UPDATE_BODY_MENU',
      'UPDATE_MENU',
      'UPDATE_TOTAL_CREATED_IMAGES',
      'UPDATE_TOTAL_CREATED_DOCUMENTS',
      'UPDATE_TOTAL_CREATED_FOLDERS',
      'SET_FIRSTNAME',
      'SET_LASTNAME',
      'SET_EMAIL',
      'SET_PHONE',
      'SET_POSITION',
      'SET_DEPARTMENT',
      'SET_COUNTRY',
      'SET_DATE_CREATED',
      'SET_ACCT_TYPE',
      'SET_ISADMIN',
      'SET_PHOTO',
      'UPDATE_TOTAL_SPACE',
      'UPDATE_DEFAULT_FOLDER',
      'UPDATE_TOTAL_USED_SPACE',
      'SET_ISTRIAL',
      'SET_ISSTAFF',
      'SET_ISSUPERADMIN',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'HIDE_FILE_INFO',
      'SET_FILE_ACTION',
      'SET_SELECT_ALL',
      'SET_USER_PLAN',
      'SET_CURRENT_PLAN',
      'UPDATE_PUBLIC_FOLDER_ID',
      'UPDATE_USER',
      'SET_NAME',
      'SET_IS_SECURITY_QUESTION',
      'SET_PLAN_STATUS',
      'SET_TRIAL_STATUS',
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    invite() {
      this.$refs.invite.load();
    },
    change_pic() {
      this.UPDATE_SLIDEIN(false)
      this.UPDATE_SLIDEOUT(true)
      this.UPDATE_MENU(false)
      this.UPDATE_BODY_MENU(false)

      this.$refs.pic.click()
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0])
      this.$refs.pic.value = ''
    },
    slideout($evt) {
      if ($evt.target.tagName === 'svg' || $evt.target.tagName === 'path') {
        this.UPDATE_SLIDEIN(false)
        this.UPDATE_SLIDEOUT(true)
        this.UPDATE_MENU(false)
        this.UPDATE_BODY_MENU(false)
      } else {
        if ($evt.target.classList.contains('menubody')) {
          this.UPDATE_SLIDEIN(false)
          this.UPDATE_SLIDEOUT(true)
          this.UPDATE_MENU(false)
          this.UPDATE_BODY_MENU(false)
        }
      }
    },
    update(selectedVar) {
      // Parse the Data
      d3.csv('https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/barplot_change_data.csv', function (data) {
        // X axis
        x.domain(data.map(function (d) { return d.group }))
        xAxis.transition().duration(1000).call(d3.axisBottom(x))

        // Add Y axis
        y.domain([0, d3.max(data, function (d) { return +d[selectedVar] })])
        yAxis.transition().duration(1000).call(d3.axisLeft(y))

        // variable u: map data to existing bars
        var u = svg.selectAll('rect')
          .data(data)

        // update bars
        u
          .enter()
          .append('rect')
          .merge(u)
          .transition()
          .duration(1000)
          .attr('x', function (d) { return x(d.group) })
          .attr('y', function (d) { return y(d[selectedVar]) })
          .attr('width', x.bandwidth())
          .attr('height', function (d) { return height - y(d[selectedVar]) })
          .attr('fill', '#3281cb')
      })
    },
    user_data() {
      let data = {
        token: cookies.getCookie('token')
      }

      let that = this

      this.$socket.emit('get-data', data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type)
          that.SET_ISADMIN(data.isSuperAdmin)
          that.SET_FIRSTNAME(data.firstname)
          that.SET_LASTNAME(data.lastname)
          that.SET_NAME(data.firstname + ' ' + data.lastname)
          that.SET_EMAIL(data.email)
          that.SET_PHONE(data.phone)
          that.SET_POSITION(data.position)
          that.SET_DEPARTMENT(data.department)
          that.SET_COUNTRY(data.country ? data.country : '')
          that.SET_DATE_CREATED(data.date_created)
          that.SET_PHOTO(data.photo)
          that.UPDATE_TOTAL_SPACE(data.total_space)
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used)
          that.UPDATE_USER(data.id)
          that.SET_CURRENT_PLAN(data.current_plan)
          that.SET_USER_PLAN(data.user_plan)
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_PLAN_STATUS(data.isPlanActive)
          that.SET_TRIAL_STATUS(data.isTrialActive)

          that.SET_ISTRIAL(data.isTrial)
          that.SET_ISSTAFF(data.isStaff)
          that.SET_ISSUPERADMIN(data.isSuperAdmin)

          that.SET_IS_SECURITY_QUESTION(data.is_security_question)

          that.UPDATE_DEFAULT_FOLDER(data.default_folders)

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id)

          localStorage.setItem('email', data.email)
          localStorage.setItem('is_security_question', data.is_security_question)
          sessionStorage.setItem('gi', data.group_folder_id)
          sessionStorage.setItem('pi', data.project_folder_id)

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images)
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents)
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders)
        } else {
          that.$router.push('/login')
        }
      })
    }
  },
  mounted() {
    this.user_data()

    let that = this
    if (cookies.getCookie('token') !== '' && cookies.getCookie('token') !== null) {
      let data = {
        token: cookies.getCookie('token'),
        load_quota: true
      }

      this.$socket.emit('url:auth', data, (data) => {
        if (data.data == false) {
          that.$router.push('/login')
        } else {
          // set the dimensions and margins of the graph
          var margin = { top: 30, right: 30, bottom: 70, left: 60 }
          var width = 760 - margin.left - margin.right
          var height = 500 - margin.top - margin.bottom

          // append the svg object to the body of the page
          var svg = d3.select('#my_dataviz')
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform',
              'translate(' + margin.left + ',' + margin.top + ')')

          // Initialize the X axis
          var x = d3.scaleBand()
            .range([0, width])
            .padding(0.2)
          var xAxis = svg.append('g')
            .attr('transform', 'translate(0,' + height + ')')

          // Initialize the Y axis
          var y = d3.scaleLinear()
            .range([height, 0])
          var yAxis = svg.append('g')
            .attr('class', 'myYaxis')

          // svg.append('g')
          // .attr('class', 'grid')
          // .attr('transform', `translate(0, ${height})`)
          // .call(d3.axisBottom()
          //     .scale(xAxis)
          //     .tickSize(-height, 0, 0)
          //     .tickFormat(''))

          // svg.append('g')
          // .attr('class', 'grid')
          // .call(d3.axisLeft()
          //     .scale(yAxis)
          //     .tickSize(-width, 0, 0)
          //     .tickFormat(''))

          svg.append('text')
            .attr('x', -(height / 2))
            .attr('y', -34)
            .attr('transform', 'rotate(-90)')
            .attr('text-anchor', 'middle')
            .text('Usage Quota (%)')

          svg.append('text')
            .attr('x', width / 2)
            .attr('y', 440)
            .attr('text-anchor', 'middle')
            .text('Files List')

          var selectedVar = 'var1'

          var data = [
            { group: 'Images', value: data.quota.images },
            { group: 'Videos', value: data.quota.video },
            { group: 'Audios', value: data.quota.audio },
            { group: 'Docs', value: data.quota.doc },
            { group: 'Sheets', value: data.quota.sheet },
            { group: 'Presentation', value: data.quota.presentation },
            { group: 'Folders', value: data.quota.folders }
          ]

          // Update the X axis
          x.domain(data.map(function (d) { return d.group }))
          xAxis.call(d3.axisBottom(x))

          // Update the Y axis
          y.domain([0, d3.max(data, function (d) { return d.value })])
          yAxis.transition().duration(1000).call(d3.axisLeft(y))

          // Create the u variable
          var u = svg.selectAll('rect')
            .data(data)

          u
            .enter()
            .append('rect') // Add a new rect for each new elements
            .merge(u) // get the already existing elements as well
            .transition() // and apply changes to all of them
            .duration(1000)
            .attr('x', function (d) { return x(d.group) })
            .attr('y', function (d) { return y(d.value) })
            .attr('width', x.bandwidth())
            .attr('height', function (d) { return height - y(d.value) })
            .attr('fill', '#3281cb')

          // If less group in the new dataset, I delete the ones not in use anymore
          u
            .exit()
            .remove()
        }
      })
    } else {
      this.$router.push('/login')
    }
  }
}
</script>
